var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShield = function SvgShield(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.319 10.342-4.148 4.148-2.489-2.489M19.1 5.921a11.268 11.268 0 0 1-6.463-2.688.989.989 0 0 0-1.274 0A11.275 11.275 0 0 1 4.9 5.921a.988.988 0 0 0-.9.991v4.33c0 4.367 3.156 8.462 7.478 9.685.339.096.706.096 1.045 0C16.844 19.703 20 15.61 20 11.243v-4.33a.988.988 0 0 0-.9-.992Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShield);
export default ForwardRef;